export default function CardsTableHelp() {
	return <div class='m-0.5 p-0.5'>Help</div>
}
